export default "__VITE_ASSET__ClfT54TB__"